const niceMax = (n) => { if (n <= 5) return 5; const p = 10 ** Math.floor(Math.log10(n)); const u = n / p; const s = u <= 1 ? 1 : u <= 2 ? 2 : u <= 5 ? 5 : 10; return s * p; };
const monthLabel = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString("en-GB", { month: "short" });

// Room-nights per month, bound to GET /client/analytics monthly_nights (12 buckets). No second series exists, so bars are single-tone.
export function ProgrammeChart({ total, points, testId = "programme-chart" }) {
  const max = niceMax(Math.max(1, ...points.map((p) => p.nights)));
  const ticks = [1, 0.75, 0.5, 0.25, 0].map((f) => Math.round(max * f));
  const sum = points.reduce((n, p) => n + p.nights, 0);
  return (
    <section data-testid={testId} className="flex flex-col rounded-[10px] border border-jigsaw-border bg-white shadow-[0_1px_3px_rgba(16,24,47,0.05)]">
      <header className="flex items-center justify-between px-5 pt-3.5">
        <h2 className="text-[16px] font-semibold text-jigsaw-navy">Your accommodation programme</h2>
        <span className="whitespace-nowrap rounded-md border border-jigsaw-border px-2.5 py-1 text-[12px] text-jigsaw-muted">Last 12 months</span>
      </header>
      <div className="flex items-end gap-3 px-5 pt-3">
        <p data-testid={`${testId}-headline`} className="text-[32px] font-bold leading-none tracking-[-0.02em] text-jigsaw-navy">{total.toLocaleString("en-GB")}</p>
        <div className="pb-0.5"><p className="text-[13px] font-medium text-jigsaw-navy">Accommodation nights</p><p className="text-[12px] text-jigsaw-muted">Room-nights, cancelled stays excluded</p></div>
      </div>
      {sum === 0 ? (
        <p data-testid={`${testId}-empty`} className="px-5 py-8 text-sm text-jigsaw-muted">No accommodation nights recorded in the last 12 months.</p>
      ) : (
        <div className="px-5 pb-3 pt-3">
          <div className="grid grid-cols-[32px_minmax(0,1fr)] gap-x-2">
            <div className="relative h-[96px]">{ticks.map((t, i) => <span key={i} className="absolute right-0 -translate-y-1/2 text-[10px] text-jigsaw-muted" style={{ top: `${i * 25}%` }}>{t}</span>)}</div>
            <div className="relative h-[96px]">
              {ticks.map((_, i) => <div key={i} className="absolute inset-x-0 border-t border-jigsaw-border/80" style={{ top: `${i * 25}%` }} />)}
              <div className="absolute inset-0 flex items-end gap-[4px] sm:gap-[6px]" role="img" aria-label="Accommodation nights per month">
                {points.map((p) => (
                  <div key={p.month} className="flex h-full flex-1 items-end" title={`${monthLabel(p.month)}: ${p.nights} nights`}>
                    <div data-testid={`${testId}-bar`} className="w-full rounded-t-[3px] bg-[#3157A4]" style={{ height: `${(p.nights / max) * 100}%` }} />
                  </div>
                ))}
              </div>
            </div>
            <div />
            <div className="mt-1.5 flex min-w-0 gap-[4px] sm:gap-[6px]">{points.map((p) => <span key={p.month} data-testid={`${testId}-month`} className="min-w-0 flex-1 text-center text-[10px] text-jigsaw-muted sm:text-[11px]"><span className="sm:hidden">{monthLabel(p.month).slice(0, 3)}</span><span className="hidden sm:inline">{monthLabel(p.month)}</span></span>)}</div>
          </div>
        </div>
      )}
    </section>
  );
}
